import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  CLEAR_BUS_CHASSIS,
  CLEAR_BUSES_CHASSIS,
  FLAG_BUS_CHASSIS_ACTIVITY,
  FLAG_GETTING_BUSES_CHASSIS,
  GET_BUS_CHASSIS,
  GET_BUSES_CHASSIS,
} from '../types';
import { BUS_CHASSIS_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_PUT_CONFIG, DEFAULT_POST_CONFIG } from '../../config/rest';
import { BUS_CHASSIS_PATH } from '../../config/paths';
import { push } from 'react-router-redux';

const flagGettingBusesChassis = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_GETTING_BUSES_CHASSIS,
  });

const getBusesChassis = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingBusesChassis(true));
    const query = tableFilters;
    const url = `${BUS_CHASSIS_ENDPOINT}?${QueryString.stringify(query)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise);
    const response = await promise.json();
    dispatch({
      type: GET_BUSES_CHASSIS,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingBusesChassis(false));
  }
};

const clearBusesChassis = () => (dispatch) =>
  dispatch({ type: CLEAR_BUSES_CHASSIS });

const flagGettingBusChassis = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_BUS_CHASSIS_ACTIVITY,
  });

const getBusChassis = async ({busChassisId}) => async (dispatch) => {
  try {
    dispatch(flagGettingBusChassis(true));
    const url = `${BUS_CHASSIS_ENDPOINT}/${busChassisId}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise);
    const response = await promise.json();
    dispatch({
      type: GET_BUS_CHASSIS,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingBusChassis(false));
  }
};

const createNewBusChassis = async ({
  
      make,
      model,
      year,
      numberOfAxles
}) => {
  const payload = {
    
      make,
      model,
      year,
      numberOfAxles
  };
  const url = BUS_CHASSIS_ENDPOINT;
  const promise = await fetch(url, {
    ...DEFAULT_POST_CONFIG,
    body: JSON.stringify(payload),
  });
  await isErrorResponse(promise);
  const endpoint = await promise.json();
  return endpoint;
};

  const postBusChassis =
    async ({
      make,
      model,
      year,
      numberOfAxles
    }) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingBusChassis(true));
        const response = await createNewBusChassis({
          
      make,
      model,
      year,
      numberOfAxles
        });
        if (response) {
          dispatch(push(`${BUS_CHASSIS_PATH}/${response.id}`));
        }
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagGettingBusChassis(false));
      }
    };

    const putBusChassis =
  async (
    busChassisId,
    {
      make,
      model,
      year,
      numberOfAxles
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingBusChassis(true));
      const payload = {
        id: busChassisId,
        
      make,
      model,
      year,
      numberOfAxles
      };
      const url = `${BUS_CHASSIS_ENDPOINT}/${busChassisId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(`${BUS_CHASSIS_PATH}/${busChassisId}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingBusChassis(false));
    }
  };

  const deleteBusChassis =
  async ({ busChassisId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingBusChassis(true));
      const url = `${BUS_CHASSIS_ENDPOINT}/${busChassisId}`;
      const promise = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(BUS_CHASSIS_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingBusChassis(false));
    }
  };

const clearBusChassis = () => (dispatch) =>
  dispatch({ type: CLEAR_BUS_CHASSIS });

export { getBusesChassis, clearBusesChassis, getBusChassis, clearBusChassis, postBusChassis, putBusChassis, deleteBusChassis };
